import React from 'react';

const KaftoraLogo = () => (
	<svg
		viewBox="0 0 800 800"
		width="100%"
		height="auto"
		xmlns="http://www.w3.org/2000/svg"
		style={{maxWidth: "180px"}}
	>
		{/* Wordmark */}
		<text
			x="400"
			y="420"
			fontSize="110"
			fontWeight="700"
			fill="currentColor"
			textAnchor="middle"
			letterSpacing="3"
			style={{fontFamily: "var(--font-display)"}}
		>
			Kaftora
		</text>

		{/* Needle underline */}
		<rect
			x="180"
			y="424"
			width="444"
			height="5"
			rx="3"
			fill="var(--gold)"
		/>
		<polygon points="181,424 182,430 160,427" fill="var(--gold)" />

		{/* Needle eye */}
		<ellipse cx="636" cy="427" rx="13" ry="4.5" fill="var(--bg)" />
		<ellipse
			cx="636"
			cy="427"
			rx="13"
			ry="4.5"
			fill="none"
			stroke="var(--gold)"
			strokeWidth="2.5"
		/>

		{/* Thread */}
		<path
			d="M649 427 C665 427 675 432 679 442 C683 452 678 465 668 470"
			fill="none"
			stroke="var(--gold)"
			strokeWidth="3"
			strokeLinecap="round"
		/>
		<path
			d="M668 470 C660 480 650 482 645 477"
			fill="none"
			stroke="var(--gold)"
			strokeWidth="2.5"
			strokeLinecap="round"
		/>
		<text
			x="400"
			y="470"
			fontSize="22"
			fill="var(--gold)"
			textAnchor="middle"
			letterSpacing="4"
			style={{fontFamily: "var(--font-display)", fontStyle: "italic"}}
		>
			Luxury In Every Thread
		</text>
	</svg>
);

export default function Footer() {
  return (
		<footer
			style={{
				background: "#0C0C0A",
				borderTop: "1px solid rgba(240,165,0,0.1)",
				padding: "28px 20px 20px",
			}}
		>
			<div style={{maxWidth: "960px", margin: "0 auto"}}>
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "flex-start",
						flexWrap: "wrap",
						gap: "24px",
						marginBottom: "16px",
					}}
				>
					{/* Brand */}
					<div>
						<div
							style={{
								display: "flex",
								alignItems: "center",
								marginBottom: "8px",
							}}
						>
							<KaftoraLogo />
						</div>
					</div>

					{/* Links */}
					{/* <div
						style={{
							display: "flex",
							gap: "24px",
							alignItems: "center",
						}}
					>
						<a
							href="#"
							style={{
								color: "var(--text-dim)",
								fontSize: "0.85rem",
								textDecoration: "none",
								transition: "color 0.2s",
							}}
							onMouseEnter={(e) =>
								(e.target.style.color = "var(--gold)")
							}
							onMouseLeave={(e) =>
								(e.target.style.color = "var(--text-dim)")
							}
						>
							Privacy Policy
						</a>
					</div> */}
				</div>

				{/* Bottom bar */}
				<div
					style={{
						borderTop: "1px solid rgba(255,255,255,0.06)",
						paddingTop: "24px",
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
						flexWrap: "wrap",
						gap: "12px",
					}}
				>
					<p style={{color: "var(--text-dim)", fontSize: "0.82rem"}}>
						© 2026 Kaftora
					</p>
					<p style={{color: "var(--text-dim)", fontSize: "0.78rem"}}>
						We will never spam you or share your information.
					</p>
				</div>
			</div>
		</footer>
  );
}
